import React from "react";
import { IconButton, makeStyles } from "@material-ui/core";
import { AddCircle, RemoveCircle } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import { decrementCameraZ, incrementCameraZ } from "../../epics/cameraEpic";
import { graphicsDarkRed } from "../../lib/constants";
import { useMobile } from "../../helperFunctions";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignSelf: "flex-end",
    marginBottom: 50,
    marginRight: 10,
    height: "fit-content",
    width: "fit-content",
    flexDirection: "column",
    pointerEvents: "all"
  },
  zoomButton: {
    fontSize: 32,
    color: graphicsDarkRed
  }
}));

export function ZoomButtons() {
  const classes = useStyles();
  const mobile = useMobile();
  const dispatch = useDispatch();
  return (
    <div className={classes.container} style={{ marginBottom: mobile ? "60px" : "50px" }}>
      <IconButton color="primary" variant="outlined" onClick={() => dispatch(incrementCameraZ())}>
        <AddCircle className={classes.zoomButton} />
      </IconButton>
      <IconButton color="primary" variant="outlined" onClick={() => dispatch(decrementCameraZ())}>
        <RemoveCircle className={classes.zoomButton} />
      </IconButton>
    </div>
  );
}
